import styled from 'styled-components';
import * as Text from '../../../styles/shared/typography';
import * as colors from '../../../styles/shared/colors';
import { respondTo } from '../../../styles/shared/breakpoints';
import { fadeIn } from '../../../styles/shared/keyframes';


const SAFETY_DRAWER_LAUNCH_BUTTON = 43;
const SAFETY_INFORMATION_DRAWER = 44;


export const CloseButton = styled.button`
 display: flex;
 width: 36px;
 padding: 1.8px 0;
 flex-direction: column;
 align-items: center;
 gap: 3.6px;
 margin: 0;
 border: none;
 background-color: transparent;
 cursor: pointer;
 color: ${colors.white};
 font-size: 10px;
 font-weight: 700;
 line-height: 1;
 box-sizing: border-box;
`;


export const ModalButtonWrapper = styled.div`
 position: relative;
 display: flex;
 align-items: center;
 justify-content: center;
 flex-shrink: 0;


 ${respondTo.md`
   align-self: flex-end;
 `}
`;


export const InformationDrawer = styled.div`
 display: none;
 position: fixed;
 z-index: ${SAFETY_INFORMATION_DRAWER};
 top: 100vh;
 left: 0;
 right: 0;
 flex-direction: column;
 height: 100%;
 width: 100%;
 max-width: 984px;
 overflow: hidden;
 margin: 0 auto;
 cursor: auto;
 transition: 0.4s transform ease-in-out;
 border-radius: 0;


 > .container {
   background-color: ${colors.white};
   overflow: hidden;
   height: 100%;
   width: 100%;
   display: flex;
   flex-direction: column;
   align-items: stretch;
   border-radius: 0;
 }


 ${respondTo.md`
   border-radius: 10px 10px 0 0;


   > .container {
     border-radius: 10px 10px 0 0;
   }
 `}


 &.information-drawer-enter {
   transform: translateY(0);
   opacity: 1;
   display: flex;
 }


 &.information-drawer-enter-active,
 &.information-drawer-enter-done {
   transform: translateY(-100vh);
   opacity: 1;
   display: flex;
 }


 &.information-drawer-exit {
   transform: translateY(-100vh);
   display: flex;
 }


 &.information-drawer-exit-active,
 &.information-drawer-exit-done {
   transform: translateY(0);
   display: flex;
 }


 &.information-drawer-exit-done {
   opacity: 0;
   display: none;
 }
`;


export const DrawerOverlay = styled.div`
 position: fixed;
 z-index: ${SAFETY_DRAWER_LAUNCH_BUTTON};
 top: 0;
 left: 0;
 right: 0;
 bottom: 0;
 height: 100vh;
 background-color: rgba(50,50,50, 0.7);
 display: ${({ isActive }) => (isActive ? 'block' : 'none')};
 animation: ${fadeIn} 0.5s;
 cursor: pointer;
`;


export const DrawerTopBar = styled.div`
 display: flex;
 justify-content: flex-end;
 align-items: center;
 align-self: stretch;
 width: 100%;
 padding: 12px 20px;
 box-sizing: border-box;
 flex-shrink: 0;
 background: linear-gradient(90deg, #2E3790 0%, #3F89C8 100%);


 ${respondTo.md`
   padding: 12px 30px;
   flex-direction: column;
   justify-content: center;
   align-items: flex-start;
 `}
`;


export const DrawerBannerText = styled(Text.Body)`
 color: ${colors.brandBlueDark};
 text-align: center;
 padding: 18px 20px 16px;
 font-size: 14px;
 line-height: 20px;
 font-weight: 600;
 background: ${colors.white};
`;


export const DrawerScrollArea = styled.div`
 flex: 1;
 overflow: auto;
 padding: 0;
 width: 100%;
 background: ${colors.white};
 display: flex;
 flex-direction: column;
 align-items: stretch;


 .blue-highlight {
   color: ${colors.weliregBlue};
   font-weight: 700;
 }
 .green-highlight {
   color: #008542;
   font-weight: 700;
 }
 .purple-highlight {
   color: #8c2d8c;
   font-weight: 700;
 }
 .spacing-expand {
   display: inline-block;
   margin-top: 6px;
 }
 .darkColor {
   color: ${colors.black};
 }
`;


// CLOSE control — X icon above label (gap handled by CloseButton)
export const CloseIcon = styled.span`
 position: relative;
 display: block;
 width: 14px;
 height: 14px;
 flex-shrink: 0;


 &:before,
 &:after {
   content: '';
   position: absolute;
   top: 50%;
   left: 50%;
   display: block;
   width: 2px;
   height: 14px;
   border-radius: 10px;
   background-color: ${colors.white};
 }


 &:before {
   transform: translate(-50%, -50%) rotate(45deg);
 }


 &:after {
   transform: translate(-50%, -50%) rotate(-45deg);
 }
`;
